'use client'

import styles from './PageContent.module.scss'
import classNames from 'classnames/bind'
const classes = classNames.bind(styles)

export default function PageContent({ children, ...props }) {
    return (
        <div className={classes('main-container')}>
            <div className={classes('child-container')} {...props}>
                {children}
            </div>
        </div>
    )
}
